import React from 'react';
import Slider from 'react-slick';
// import 'slick-carousel/slick/slick.css';
// import 'slick-carousel/slick/slick-theme.css';

const TestimonialAbout = () => {
    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
    };

    const testimonials = [
        {
            text: "I had an amazing experience with SHREE Tours & Travels! The journey was seamless and the team took care of every detail. I highly recommend their services for a comfortable and hassle-free trip.",
            author: "Mr. Arun Patel",
            designation: "Managing Director",
        },
        {
            text: "SHREE Tours & Travels provided an unforgettable trip for our group. The vehicles were top-notch and the staff was friendly and professional. A truly great travel experience!",
            author: "Mrs. Sunita Sharma",
            designation: "Event Planner",
        },
        {
            text: "Our family vacation was made even more special by SHREE Tours & Travels. They offered personalized service and the trip was stress-free. I would definitely book with them again!",
            author: "Mr. Rajeev Kumar",
            designation: "Business Executive",
        },
        {
            text: "Excellent service and attention to detail from SHREE Tours & Travels. The trip was smooth, the driver was courteous and the vehicle was well-maintained. Highly recommend!",
            author: "Miss. Anjali Reddy",
            designation: "Marketing Manager",
        },
        {
            text: "SHREE Tours & Travels made our corporate trip easy and enjoyable. The entire experience was well-organized and we were able to focus on our work while traveling comfortably. Great service!",
            author: "Mr. Vikram Singh",
            designation: "Corporate Head",
        },
    ];
    

    return (
        <section className="testimonial-section-three ">
            <div className="bg bg-image "></div>
            <div className="image-man"></div>
            <div className="container pt-0 pb-0">
                <div className="row justify-content-xl-end  g-0 ">
                    <div className="col-xl-7">
                        <div className="sec-title">
                            <h2 className="letters-slide-up text-split">Happy Customers </h2>
                        </div>
                        <Slider {...settings} className="testimonial-carousel ">
                            {testimonials.map((item, index) => (
                                <div className="testimonial-block-three " key={index}>
                                    <div className="inner-box">
                                        <div className="content">
                                            <div className="text">{item.text}</div>
                                            <div className="box-info">
                                                <div className="author-box">
                                                    <figure className="author-image">
                                                    </figure>
                                                    <div className="author-info">
                                                        <h4 className="name">{item.author}</h4>
                                                    </div>
                                                </div>
                                                <div className="author-rating">
                                                    <div className="rating-title">Quality Services</div>
                                                    <div className="rating">
                                                        <i className="fa fa-star"></i>
                                                        <i className="fa fa-star"></i>
                                                        <i className="fa fa-star"></i>
                                                        <i className="fa fa-star"></i>
                                                        <i className="fa fa-star"></i>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </Slider>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default TestimonialAbout;
